<template>
  <div class="tour-wrap" :style="{minHeight: tourHeight + 'px'}">
    <transition enter-active-class="page-moveFromRightFade" leave-active-class="page-moveToLeftFade" type="animation" appear>
      <div v-if="!isStart" key="intro" class="tour-intro" :style="'background-image: url(' + baseUrl + bgimage + '); background-position: center center; background-repeat: no-repeat; background-size: cover'">
        <div class="body-wrap">
          <div class="container">
            <slot name="cover"></slot>
            <button v-if="preview" disabled class="button button-start is-disabled is-success is-rounded">{{ $t("tour_disabled") }}</button>
            <button v-else class="button button-start is-success is-rounded" @click="startTour">{{ $t("tour_start") }}</button>
          </div>
        </div>
      </div>
      <div v-else key="cource" class="tour-course">
        <hooper
          :itemsToShow="5"
          :centerMode="true"
          :settings="hooperNavSettings"
          group="group1"
          class="spot-number"
          ref="progressBar"
        >
        <hooper-progress slot="hooper-addons"></hooper-progress>
        <slide v-for="item in items" :key="item.id">
          <div class="clickable-area" :data-slide-index="item.num" @click="locationClickHandler">
            <span :data-slide-index="item.num">{{item.num}}</span>
          </div>
        </slide>
        </hooper>
        <hooper
          :progress="true"
          :itemsToShow="1.16"
          :centerMode="true"
          :infiniteScroll="false"
          :settings="hooperSettings"
          @updated="update"
          @beforeSlide="beforeSlide"
          @slide="sliding"
          @afterSlide="afterSlide"
          group="group1"
          id="page-slide"
          class="tour-slider"
        >
          <slot name="spots"></slot>
          <hooper-navigation slot="hooper-addons">
            <span ref='next' class="hooper-button icon-keyboard_arrow_left" slot="hooper-prev"></span>
            <span ref='prev' class="hooper-button icon-keyboard_arrow_right" slot="hooper-next"></span>
          </hooper-navigation>
        </hooper>
        <div class="page-overray lower-z-index" ref="pageoverray" @click="listVisibility(false)" v-touch:moving="movingHandler" v-touch:start="startHandler" v-touch:end="endHandler"></div>
        <transition enter-active-class="page-scaleUp" leave-active-class="page-scaleDown" type="animation" appear>
          <a
            v-if="!showList"
            class="fab"
            @click="listVisibility(true)"
          >
            <span class="icon-footprint"></span>
          </a>
        </transition>
        <transition enter-active-class="page-flipInLeft" leave-active-class="page-flipOutLeft" type="animation" appear>
          <div v-if="showList" id="spotList" class="spots_list duration-200" :style="listStyle" ref="spotList" v-touch:moving="movingHandler" v-touch:start="startHandler" v-touch:end="endHandler">
            <ul id="spotListScrollbar">
              <li
                v-for="item in items"
                :key="item.id"
                :id="'spot_' + item.num"
                class="clickable-area"
                :class="{'is-active': currentPos == item.num}"
                :data-slide-index="item.num"
                @click="locationClickHandler"
              >
                {{item.title}}
              </li>
            </ul>
            <span class="close-tab" @click="listVisibility(false)"><span class="icon-keyboard_arrow_right"></span></span>
          </div>
        </transition>
      </div>

    </transition>

  </div>
</template>

<script>
import _ from 'lodash'
import { mapGetters, mapActions } from 'vuex'
import Scrollbar, { ScrollbarPlugin } from 'smooth-scrollbar'
import OverscrollPlugin from 'smooth-scrollbar/plugins/overscroll'

import { Hooper, Slide, Navigation as HooperNavigation, Progress as HooperProgress, } from 'hooper'
import 'hooper/dist/hooper.css'

class DisableScrollPlugin extends ScrollbarPlugin {
  static pluginName = 'disableScroll';

  static defaultOptions = {
    direction: null,
  };

  transformDelta(delta) {
    if (this.options.direction) {
      delta[this.options.direction] = 0;
    }
    return { ...delta };
  }
}

Scrollbar.use(DisableScrollPlugin)
Scrollbar.use(OverscrollPlugin)

export default {
  props: {
    items: {
      type: Array,
      default: function() {
        return []
      }
    },
    bgimage: {
      type: String,
      default: null
    },
    preview: {
      type: Boolean,
      default: false
    }
  },
  components: {
    Hooper,
    Slide,
    HooperNavigation,
    HooperProgress,
  },
  data(){
    return{
      baseUrl: process.env.VUE_APP_BASE_URL,
      isStart: false,
      slides: [],
      scrollbars: [],
      currentPos: 1,
      showList: false,
      appWrap: null,
      pageWrap: null,
      page: null,
      tourHeight: 0,
      brandId: null,
      screenHeight: 0,
      globalNavHeight: 68,
      hooperNavHeight: 48,
      hooperNavSettings: {
        wheelControl: true,
        breakpoints: {
          1024: {
            itemsToShow: 10,
          },
          0: {

          }
        },
      },
      hooperSettings: {
        wheelControl: false,
        breakpoints: {
          1024: {
            itemsToShow: 3.27,
          },
          0: {

          }
        },
        windowHeight: 0,
        slideHeight: 0,
      },
      scrollOptions: {
        container: '#spotList ul',
        easing: 'linear',
        offset: 0,
        force: true,
        cancelable: true,
        x: false,
        y: true
      },
      scrollBarOption: {
        damping: 0.1,
        renderByPixels: true,
        alwaysShowTracks: false,
        continuousScrolling: true,
        plugins: {
          overscroll: true,
          disableScroll: { direction: 'x' }
        },
      },
      touchStartPos: 0,
      touchCurrentPos: 0,
      rightPos: 0,
      rightMaxPos: 90,
      touching: false,
    }
  },

  computed: {
    ...mapGetters([
      'getGuideVisibility',
    ]),
    currentSpot: function () {
      return '#spot_' + this.currentPos
    },
    spotListHeight: function () {
      return this.tourHeight - this.hooperNavHeight
    },
    listStyle () {
        return {
          transform: 'translateX(' + this.rightPos + 'px)',
          height: this.tourHeight - this.hooperNavHeight + 'px'
        }
    }
  },

  watch: {
    getGuideVisibility (newValue, oldValue) { // eslint-disable-line no-unused-vars
      // console.log(oldValue)
      if(this.isStart){
        if(newValue == true){
          this.releaseScroll()
        } else {
          this.lockScroll()
          this.update()
        }
      }
    },
    $route (){
      this.isStart = false
    },
  },

  beforeMount() {},

  mounted() {
    window.addEventListener('resize', this.handleResize, { passive: false })

    this.appWrap  = document.getElementById('app')
    this.pageWrap = document.getElementById('page-wrap')
    this.page     = document.querySelector('.page')
    this.brandId  = document.querySelector('.brand-id')

    this.setFooterTextColor({ color: '#fff' })
  },

  beforeDestroy() {
    this.isStart = false
    this.slides = []
    this.scrollbars = []
    this.currentPos = 1
    this.showList = false
    this.page.classList.remove('tour-start')
    this.setFooterTextColor({ color: '#000' })
  },

  methods: {
    ...mapActions([
      'setFooterTextColor',
    ]),
    lockScroll: function(){
      this.slideHeight = this.screenHeight - this.globalNavHeight - this.hooperNavHeight
    },
    releaseScroll: function(){
      this.slideHeight = -1
      this.update()
    },
    startTour: function(e){
      e.target.classList.add('is-loading')
      this.init()
      // this.$nextTick(()=>this.isStart = true)
      setTimeout(() => {
        this.isStart = true
      }, 650)
    },
    locationClickHandler: function(e){
      const index = e.target.getAttribute("data-slide-index")
      this.$refs.progressBar.slideTo(index - 1)
      this.$refs.pageoverray.classList.remove('is-active')
      this.showList = false
      // console.log(this.currentPos)
    },
    init: function() {
      this.globalNavHeight = this.brandId.clientHeight
      this.screenHeight = document.documentElement.clientHeight
      this.page.classList.add('tour-start')
      this.lockScroll()
    },
    update: function(payload) { // eslint-disable-line no-unused-vars
      // console.log('update', payload)
      const pageSlide = document.getElementById("page-slide")
      this.slides = pageSlide.querySelectorAll('.hooper-slide')
      this.slides.forEach(function(slide) {
        if(this.slideHeight < 0){
          slide.style.height = 'auto'
        } else {
          slide.style.height = this.slideHeight + "px"
          // set FAB buttons Y position for when Help Button was activated
        }
      }.bind(this))

      this.tourHeight = pageSlide.clientHeight + this.hooperNavHeight

      this.appWrap.style.minHeight  = this.tourHeight + "px"
      this.pageWrap.style.minHeight = this.tourHeight + "px"
      this.page.style.minHeight     = this.tourHeight + "px"

      if(this.getGuideVisibility == false){
        this.$refs.next.style.height = pageSlide.clientHeight + "px"
        this.$refs.prev.style.height = pageSlide.clientHeight + "px"
      }

      this.scrollbars = Scrollbar.initAll(this.scrollBarOption)

      setTimeout(() => {
        this.setFooterTextColor({ color: '#000' })
      }, 800);

      this.scrollbars.forEach(function(scrollbar){
        // console.log('size', scrollbar.getSize())
        scrollbar.scrollTo(0, 0, 0, {
          // callback: () => console.log('done!')
        });
      }.bind(this))

    },
    beforeSlide: function(payload) { // eslint-disable-line no-unused-vars
      // console.log(payload)
    },
    sliding: function(payload){
      if(this.currentPos != payload.currentSlide + 1){
        this.currentPos = payload.currentSlide + 1
      }
    },
    afterSlide: function(payload){ // eslint-disable-line no-unused-vars
      // console.log(payload)
    },
    handleResize: function() {
      this.init()
      this.update()
    },
    listVisibility: function(status){
      this.showList = status
      if(this.showList){
        // console.log('showlist true')
        this.rightPos = 0
        this.$refs.pageoverray.classList.add('is-active')
      } else {
        // console.log('showlist false')
        this.$refs.pageoverray.classList.remove('is-active')
      }
      // this.$refs.spotList.style.display = this.showList ? 'block' : 'none'
      const self = this
      this.$nextTick(function(){
        Scrollbar.init(document.getElementById('spotListScrollbar'))
        const element = document.getElementById('spot_' + self.currentPos)
        if(element){
          self.$scrollTo(element, 1, self.scrollOptions)
        }
      })
    },
    scrollHandler: function(selector){
      const num = this.currentPos -1
      const scb = this.scrollbars[num]
      const trg = document.querySelector(selector)
      const pos = trg.offsetTop
      scb.scrollTo(0, pos, 600)
    },
    startHandler: function(e){
      if(e.touches && e.touches.length > 0){
        this.touchStartPos = e.touches[0].screenX
      } else {
        this.touchStartPos = e.screenX
      }
      this.touching = true
    },
    endHandler: function(e){
      if(e.touches && e.touches.length > 0){
        this.touchCurrentPos = e.touches[0].screenX
      } else {
        this.touchCurrentPos = e.screenX
      }
      this.touching = false
      this.touchMove()
    },
    movingHandler: function(e){
      if(e.touches && e.touches.length > 0){
        this.touchCurrentPos = e.touches[0].screenX
      } else {
        this.touchCurrentPos = e.screenX
      }
      this.touchMove()
    },
    touchMove: function(){
      const diff = this.touchCurrentPos - this.touchStartPos
      if(this.touching){
        if(diff > 0){
          if(Math.abs(this.rightPos) >= this.rightMaxPos) {
            this.touching = false
          } else {
            _.throttle(()=>{ this.rightPos = diff }, 50)()

          }
        } else {
          this.rightPos = 0
        }
      } else {
        if(Math.abs(this.rightPos) >= this.rightMaxPos/2) {
          this.listVisibility(false)
        } else {
          this.rightPos = 0
        }
      }
    }
  }
}
</script>
<style lang="sass"></style>
